/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
/**
 * author: tman
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Row, Col ,HelpBlock} from 'react-bootstrap';
import InputText from '../InputText/InputText';

const InputMobile = (props) => {
    const {
        content,
        mobilePhoneChangeAction,
        questionRel,
        countryOverlapLabel,
        isError,
        errorMessage,
        handleBlurAction
    } = props;
    const valueDidChange = (values) => {
        const finalValue = values.join("-");
        mobilePhoneChangeAction && mobilePhoneChangeAction(questionRel, finalValue)
    };

    const handlePhone = (index) => (rel, val) => {
        const countryCode = content.areaItem.textValue;
        const phoneNum = content.phoneItem.textValue;
        switch (index) {
            case 0:
                valueDidChange([val, phoneNum]);
                break;
            case 1:
                valueDidChange([countryCode, val]);
                break;
            default:
                break;
        }
    };

    return (
        <div className="phone-text-box clearfix">
            <FormGroup validationState={isError ? 'error' : null}>
                <Row className="input-date-wrap mobile-number-wrap phone-number-wrap combined-group-wrap">
                    <Col xs={4} md={4} lg={4} className="group-item country-code reserved-item-input">
                        <InputText
                            handleTextChange={ handlePhone(0) }
                            content={content.areaItem}
                            type={'tel'}
                            maxLength={3}
                            colParameter={{
                                md: 12,
                                xs: 12
                            }}
                            overlapLabel={countryOverlapLabel}
                            handleBlurAction={handleBlurAction}
                            ariaDescribedby={`${questionRel.questionId}-fieldError`}
                        />
                    </Col>

                    <Col xs={8} md={8} lg={8}
                         className="group-item mobile-number"
                    >
                        <InputText
                            handleTextChange={ handlePhone(1) }
                            content={content.phoneItem}
                            type={'tel'}
                            maxLength={11}
                            colParameter={{
                                md: 12,
                                xs: 12
                            }}
                            handleBlurAction={handleBlurAction}
                            ariaDescribedby={`${questionRel.questionId}-fieldError`}
                        />
                    </Col>
                </Row>
                <HelpBlock id = {`${questionRel.questionId}-fieldError`}>{errorMessage }</HelpBlock>
            </FormGroup>
        </div>
    )
};


InputMobile.propTypes = {
    content: PropTypes.object.isRequired,
    isError: PropTypes.bool,
    mobilePhoneChangeAction: PropTypes.func,
    questionRel: PropTypes.object,
    errorMessage:PropTypes.string,
    countryOverlapLabel:PropTypes.object,
    handleBlurAction:PropTypes.func,
};

InputMobile.defaultProps = {
    content:{},
    disabled:false,
    countryOverlapLabel:{
        float:'left',
        labelContent:'+'
    }
};

export default InputMobile;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/InputMobile/index.js